import { validatePassword } from './validatePassword';
import { submitPasswordChange } from './submitPasswordChange';
import { requestPasswordChange } from './requestPasswordChange';
import { validateResetToken } from './validateResetToken';

export interface IPassword {
  validatePassword: typeof validatePassword;
  submitPasswordChange: typeof submitPasswordChange;
  requestPasswordChange: typeof requestPasswordChange;
  validateResetToken: typeof validateResetToken;
}

/**
 * @namespace
 */
const Password: IPassword = {
  validatePassword,
  submitPasswordChange,
  requestPasswordChange,
  validateResetToken,
};

export default Password;
